import { PrismicNextImage, PrismicNextLink } from "@prismicio/next";
import { PrismicRichText } from "@prismicio/react";

export default function TilesBlock({ slice, className = "" }) {
  return (
    <div
      className={`flex flex-col items-stretch relative z-[5] bg-[#1F2223] lg:bg-transparent ${className}`}
    >
      <div className="md:flex md:flex-row">
        {slice?.tiles?.map((item, idx) => {
          return (
            <PrismicNextLink
              field={item.link}
              key={idx}
              className={`
                block lg:hover:bg-[#1F2223] duration-200
                border-[rgba(255,255,255,0.3)]
                border-b-[0.5px] md:border-b-0 md:border-r-[0.5px] last:border-b-0 md:last:border-r-0
                w-full py-[24px] md:py-[32px] md:px-[18px]
                `}
            >
              <div className="w-full max-w-[232px] mx-auto flex flex-nowrap items-center gap-[24px] md:gap-[12px]">
                {item.icon?.url && (
                  <PrismicNextImage
                    className="h-[55px] w-[55px]"
                    field={item.icon}
                    fallbackAlt=""
                    loading="lazy"
                  />
                )}
                <div>
                  <div className="text-[#EEB978]">
                    <PrismicRichText field={item.sub_text} />
                  </div>
                  <div className="title-font text-[#FFFFFF]">
                    <PrismicRichText field={item.main_text} />
                  </div>
                </div>
              </div>
            </PrismicNextLink>
          );
        })}
      </div>
    </div>
  );
}
